var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDownloadIconNew = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.703235 9.04393C0.323265 8.69481 0.319308 8.09663 0.694628 7.74251C1.03425 7.42207 1.56388 7.41893 1.90727 7.73533L4.33185 9.96926L4.33185 1.69823C4.33185 1.18007 4.75191 0.760009 5.27008 0.760009C5.78824 0.760009 6.2083 1.18007 6.2083 1.69823L6.2083 9.96926L8.67196 7.71416C9.01542 7.39978 9.54388 7.40582 9.88007 7.72796C10.2484 8.08093 10.2422 8.6716 9.86655 9.01677L5.94666 12.6184C5.56409 12.9699 4.97607 12.9699 4.5935 12.6184L0.703235 9.04393Z",
    fill: "#6A778E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadIconNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download-icon-new.aa21a77b.svg";
export { ForwardRef as ReactComponent };